import { render, staticRenderFns } from "./reisen-view.vue?vue&type=template&id=5b0016ae&scoped=true"
import script from "./reisen-view.vue?vue&type=script&lang=js"
export * from "./reisen-view.vue?vue&type=script&lang=js"
import style0 from "./reisen-view.vue?vue&type=style&index=0&id=5b0016ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0016ae",
  null
  
)

export default component.exports